import './App.css';
import './css/NavBar.css'; 
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from "./components/Home";
import About from "./components/About";
import SinglePost from "./components/SinglePost";
import Posts from "./components/Posts";
import Projects from "./components/Projects";
import Navbar from './components/NavBar';


function App() {
  return (
    <BrowserRouter basename="/blog">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/posts/:slug" element={<SinglePost />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
